import { useLanguage } from "../context/LanguageContext";

export default function Header() {
  const { setLang, lang } = useLanguage();
  return (
    <header className="w-full flex h-28 bg-gray-950 relative">
      <div className="w-1/6 flex justify-center items-center">
        <img
          className="w-20 h-18 mx-auto my-auto"
          src={`${process.env.PUBLIC_URL}/concilia_logo.png`}
          alt="Logo do projeto ConcilIA em branco com fundo escuro."
        />
      </div>
      <p className="w-5/6 my-auto text-4xl font-mono text-slate-100 ml-6">
        <span className="font-thin">Concil-</span>
        <span className="font-black">IA</span>
      </p>

      <div className="absolute top-4 right-4 flex gap-3">
        <button
          onClick={() => setLang("pt")}
          className={`fi fi-br text-xl transition-opacity ${
            lang === "pt" ? "opacity-100" : "opacity-40"
          }`}
        ></button>

        <button
          onClick={() => setLang("en")}
          className={`fi fi-us text-xl transition-opacity ${
            lang === "en" ? "opacity-100" : "opacity-40"
          }`}
        ></button>
      </div>

    </header>
  );
}
